__turbopack_context__.v({
  "className": "geist_mono_66039167-module__O0reuq__className",
  "variable": "geist_mono_66039167-module__O0reuq__variable",
});
